module.exports = __webpack_public_path__ + "assets/img/0c33e9d3776631c42445792752ae3c2e.png";